import { ORPCError } from '@orpc/client';
import {
  VdmProvinceOverrideRequiredDataSchema,
  type VdmProvinceOverrideRequiredData,
} from '@erp/shared-types';

/**
 * What a "Link a VDM" failure is asking, when it is the server saying the
 * selected transactions are in AB but the memo is billed to BC (or the reverse)
 * and this user may confirm a Province override: a CONFLICT carrying
 * `data.code = "VDM_PROVINCE_OVERRIDE_REQUIRED"`. The dialog answers it with a
 * "Link Anyway" warning instead of an error toast.
 *
 * Null for every other failure.
 */
export function readVdmProvinceOverrideRequired(
  error: unknown,
): VdmProvinceOverrideRequiredData | null {
  if (!(error instanceof ORPCError) || error.code !== 'CONFLICT') return null;
  const parsed = VdmProvinceOverrideRequiredDataSchema.safeParse(error.data);
  return parsed.success ? parsed.data : null;
}
